const flattenPages = pages =>
  pages ? pages.reduce((items, page) => [...items, ...page.data], []) : [];

export default flattenPages;
